"use strict";

const ToDoMapTable = function () {
  const expandedSections = new Set();
  let dataView;
  let selectedSubject = null;
  let highlightSubject = null;
  let todoIdSets = {};

  var init = function () {
    loadListeners();
    BmpFcsTodoController.setTodoMapBmpFcsRadioButtons();
    loadTodosIfNecessary();
  };

  var _setDataView = function (newDataView) {
    if (dataView && newDataView !== dataView) {
      ToDoListController.unsetData();
      setSelectedSubject(null);
    }

    dataView = newDataView;
  };

  var loadTodosIfNecessary = function () {
    const activeTab = Tree.get("activeTab");

    if (activeTab === "todo" && !ToDoListController.hasData()) {
      load(dataView);
    }
  };

  var loadListeners = function () {
    _setDataView(Tree.get("dataView"));

    Tree.select("activeTab").off("update", onActiveTabChange);
    Tree.select("activeTab").on("update", onActiveTabChange);

    Tree.select(["table", "dataSort"]).off("update", onDataSortUpdate);
    Tree.select(["table", "dataSort"]).on("update", onDataSortUpdate);

    Tree.select("activeTab").off("update", onTabOrNaveUpdate);
    Tree.select("activeTab").on("update", onTabOrNaveUpdate);
    Tree.select("navToggleSelection").off("update", onTabOrNaveUpdate);
    Tree.select("navToggleSelection").on("update", onTabOrNaveUpdate);

    const $todoMapTableContainer = $("#todo-map-table-container");
    const $bottomFloatingInputsTable = $("#bottomFloatingInputsTable");

    $todoMapTableContainer.off("click", ".todo-subject-header h3", toggleToDoSubjectHeader);
    $todoMapTableContainer.on("click", ".todo-subject-header h3", toggleToDoSubjectHeader);
    $todoMapTableContainer.off("click", ".toggle-btn", toggleAllSections);
    $todoMapTableContainer.on("click", ".toggle-btn", toggleAllSections);
    $bottomFloatingInputsTable.off("click", ".rollups-container", onRollUpClick);
    $bottomFloatingInputsTable.on("click", ".rollups-container", onRollUpClick);
    $todoMapTableContainer.off("click", ".todo-filter-button", toDoFilterButtonClick);
    $todoMapTableContainer.on("click", ".todo-filter-button", toDoFilterButtonClick);
    $todoMapTableContainer.off("click", ".todo-filter-label", toDoFilterLabelClick);
    $todoMapTableContainer.on("click", ".todo-filter-label", toDoFilterLabelClick);
  };

  var update = async function () {
    _setDataView(Tree.get("dataView"));
    const todoMapTableData = _getToDoDataSubjectData();

    if (!todoMapTableData) {
      return;
    }

    createTodoIdSets(todoMapTableData);
    renderToDoMapTable(todoMapTableData);
  };

  var onDataSortUpdate = function () {
    if (Tree.get("activeTab") === "todo" && Tree.get("navToggleSelection") === "map") {
      collapseTodoMapTable();
    }
  };

  var enableDropdownIncidentsInsight = function (tab) {
    if ((tab === "insight" || tab === "todo") && Tree.get("dataView") === "incidents") {
      $(".navbar-dropdown").removeClass("disabled");
    }
  };

  var onTabOrNaveUpdate = function (e) {
    const $todoMapTableContainer = $("#todo-map-table-container");
    const $bottomFloatingInputsTable = $("#bottomFloatingInputsTable");

    const activeTab = Tree.get("activeTab");
    enableDropdownIncidentsInsight(activeTab);
    const navToggleSelection = Tree.get("navToggleSelection");

    if (activeTab === "todo" && navToggleSelection === "map") {
      $todoMapTableContainer.show();
      MainMapController.handleMapListToggleDisplay();

      Mobile.setVisibleOnMobile($bottomFloatingInputsTable, true);
    } else {
      $todoMapTableContainer.hide();
      Mobile.setVisibleOnMobile($bottomFloatingInputsTable, false);
      MainMapController.handleMapListToggleDisplay();
    }
  };

  var onActiveTabChange = function (e) {
    const dataView = Tree.get("dataView");
    const activeTab = e.data.currentData;

    handleAttributechangesBasedOnTabSbmps(dataView, activeTab);
    loadTodosIfNecessary();

    Actions.selectCatchmentsByFilter();
    if (!_isLidBmpLayerEnabled()) {
      updateToDoMapLayers();
    }

    DataViewFunctions.getCurrentDataViewProperty("activeTabChangeCallback", dataView)?.(
      activeTab,
      dataView,
    );

    SmartFilterRegistry.getSummary()?.render();
  };

  var _isLidBmpLayerEnabled = function () {
    return Tree.get(["layers", "lidProjectBmp", "isEnabled"]);
  };

  var handleAttributechangesBasedOnTabSbmps = function (dataView, activeTab) {
    const isGis = DataViewFunctions.getCurrentDataViewProperty("isGisDataView");
    const layerType = sessionStorage.getItem("geoServerLayerType");

    if (dataView === "lid-project") {
      $("#radio-lid-project-main").val("postConstructionProjectG2");
      $("#check-cluster-lid-project-main").attr("data-layer", "postConstructionProjectG2");
      $("#check-cluster-lid-project-main").attr("name", "super-cluster");
      $("#radio-phase-lid-project-main").attr("data-layer", "postConstructionProjectG2");
      if (isGis && layerType === "WFS") {
        $("#check-cluster-lid-project-main").prop("checked", true);
      } else if (isGis && layerType === "WMS") {
        $("#check-cluster-lid-project-main").prop("checked", false);
      }
    }
    if (dataView === "bmp" && activeTab === "todo") {
      $("#radio-bmps-main").val("bmps");
      $("#check-cluster-bmps-main").attr("data-layer", "bmps");
      $("#check-cluster-bmps-main").attr("name", "cluster");
      $("#radio-phase-bmps-main").attr("data-layer", "bmps");
      $("#radio-condition-bmps-main").attr("data-layer", "bmps");
    }
    if (dataView === "bmp" && activeTab === "data") {
      const conditionalPhaseLogic = Tree.get("filters", "conditionPhaseToggle");
      $("#radio-bmps-main").val("structuralBmps");
      $("#check-cluster-bmps-main").attr("data-layer", "structuralBmps");
      $("#check-cluster-bmps-main").attr("name", "super-cluster");
      $("#radio-phase-bmps-main").attr("data-layer", "structuralBmps");
      $("#radio-condition-bmps-main").attr("data-layer", "structuralBmps");
      if (isGis && layerType === "WFS") {
        $("#check-cluster-bmps-main").prop("checked", true);
      } else if (isGis && layerType === "WMS") {
        $("#check-cluster-bmps-main").prop("checked", false);
      }
      if (conditionalPhaseLogic === "condition") {
        $("#radio-condition-bmps-main").prop("checked", true);
      }
    }
  };

  var toggleToDoSubjectHeader = function (e) {
    var $todoSubjectParentDiv = $(this).closest(".todo-subject-parent-div");
    if (isTodoTableCollapsing($todoSubjectParentDiv)) return;

    if ($todoSubjectParentDiv.hasClass("unavailable")) {
      $(this).find(".expand-arrow").toggleClass("open");
      return;
    }

    if ($(this).find(".expand-arrow").not(".unavailable").hasClass("open")) {
      if ($todoSubjectParentDiv.hasClass("selected")) {
        collapseExpandedHeader.call(this, e);
      } else {
        reselectExpandedHeader.call(this, e);
      }
    } else {
      expandCollapsedHeader.call(this, e);
    }
  };

  var collapseExpandedHeader = function (e) {
    var $todoSubjectParentDiv = $(this).closest(".todo-subject-parent-div");
    var subject = $todoSubjectParentDiv.data("subject");
    expandedSections.delete(subject);
    $(this).find(".expand-arrow").removeClass("open");
    $todoSubjectParentDiv.removeClass("active");
    $todoSubjectParentDiv.removeClass("selected");

    var selected = $(".todo-subject-parent-div.selected").length;
    if (!selected) {
      setSelectedSubject(null);
    }

    handleExpandCollapseButtons();
  };

  var reselectExpandedHeader = function (e) {
    e.stopPropagation(); //prevent data-toggle
    clearTodoMapTableSelection();

    const $todoSubjectParentDiv = $(this).closest(".todo-subject-parent-div");
    const subject = $todoSubjectParentDiv.data("subject");
    setSelectedSubject(subject);

    $todoSubjectParentDiv.addClass("selected");
  };

  var expandCollapsedHeader = function (e) {
    clearTodoMapTableSelection();

    const $todoSubjectParentDiv = $(this).closest(".todo-subject-parent-div");
    const subject = $todoSubjectParentDiv.data("subject");
    setSelectedSubject(subject);
    expandedSections.add(subject);

    $todoSubjectParentDiv.addClass("active");
    $todoSubjectParentDiv.addClass("selected");
    if (!$(this).find(".expand-arrow").hasClass("unavailable")) {
      $(this).find(".expand-arrow").addClass("open");
    }
    handleExpandCollapseButtons();
  };

  var handleExpandCollapseButtons = function () {
    if (expandedSections.size === Object.keys(todoIdSets).length) {
      updateToggleButtonText("collapse");
    } else {
      updateToggleButtonText("expand");
    }
  };

  var _getToDoDataSubjectData = function () {
    const groupedPreparedData = ToDoListController.getAllPreparedData();
    if (!groupedPreparedData || Object.keys(groupedPreparedData).length === 0) {
      return null;
    }

    const result = {};
    for (const subject in groupedPreparedData) {
      result[subject] = {
        data: groupedPreparedData[subject],
      };
    }
    return result;
  };

  var toggleAllSections = function () {
    const $toggleBtn = $(".toggle-btn");
    const action = $toggleBtn.data("action");

    if (action === "expand") {
      expandTodoMapTable();
    } else {
      collapseTodoMapTable();
    }
  };

  var expandTodoMapTable = function (e, todoSubject, popUpOpenClick) {
    if (!popUpOpenClick) {
      clearTodoMapTableSelection();
    }

    const $todoMapTableContainer = $("#todo-map-table-container");
    let $todoSubjectParentDivs = $todoMapTableContainer.find(".todo-subject-parent-div");

    if (todoSubject) {
      $todoSubjectParentDivs = $todoMapTableContainer.find(
        ".todo-subject-parent-div[data-subject='" + todoSubject + "']",
      );
    }

    $todoSubjectParentDivs.each(function () {
      const subject = $(this).data("subject");
      expandedSections.add(subject);
    });

    $todoSubjectParentDivs
      .find(".todo-list[aria-expanded=false]")
      .parent()
      .siblings()
      .children()
      .click();
    $todoSubjectParentDivs.addClass("active");

    $todoSubjectParentDivs.find(".todo-list").addClass("collapse").addClass("in");

    $todoSubjectParentDivs.find(".expand-arrow").not(".unavailable").addClass("open");

    handleExpandCollapseButtons();
  };

  var collapseTodoMapTable = function () {
    const $todoMapTableContainer = $("#todo-map-table-container");

    updateToggleButtonText("expand");

    $todoMapTableContainer.find(".open").not(".unavailable").removeClass("open");
    $todoMapTableContainer.find(".in").not(".unavailable").removeClass("in");
    $todoMapTableContainer
      .find(".todo-subject-parent-div")
      .removeClass("selected")
      .removeClass("active");
    expandedSections.clear();
    setSelectedSubject(null);
  };

  var expandTodoHeaderContainsIdbmp = function (idBmp) {
    if (selectedSubject) {
      return;
    }

    for (const key in todoIdSets) {
      const set = todoIdSets[key];
      if (set.has(idBmp)) {
        expandTodoMapTable(null, key, true);
      }
    }
  };

  var clearTodoMapTableSelection = function () {
    const $todoMapTableContainer = $("#todo-map-table-container");
    $todoMapTableContainer.find(".todo-subject-parent-div").removeClass("selected");
    $todoMapTableContainer.find(".map-hover").removeClass("map-hover");
  };

  var load = function () {
    const filters = Tree.get("filters");
    ToDoListController.loadTodosIfNecessary(filters);
  };

  var createTodoIdSets = function (todoMapTableData) {
    todoIdSets = {};

    for (const key in todoMapTableData) {
      const todos = todoMapTableData[key].data;
      const set = new Set();

      todos.forEach(function (item) {
        if (item.id) {
          set.add(item.id);
        } else {
          set.add(item.relatedId);
        }
      });

      todoIdSets[key] = set;
    }

    updateToDoMapLayers();
    return todoIdSets;
  };

  var renderToDoMapTable = function (todoMapTableData) {
    const $mapTable = $("#todo-map-table");
    $mapTable.html("");

    DataViewFunctions.getUserEnabledToDoSubjects(dataView).forEach((subject) => {
      const subjectConfig = ToDoConfig.getToDoSubjectConfig([subject]);
      const html = nunjucks.render("table/toDo/toDoMapTableSection.njk", {
        subject,
        ...subjectConfig,
        todos: todoMapTableData[subject].data,
        filterLabels: Tree.get(["toDoFilterLabels", dataView])?.[subject],
        showToDoFilterButton: ToDoFunctions.getIsToDoFilterEnabled(subject),
        expanded: expandedSections.has(subject),
        selected: subject === selectedSubject,
        dataView: Tree.get("dataView"),
      });
      $mapTable.append(html);
    });

    $(".todo-map-table-header .todo-filter-button").toggle(
      !!DataViewFunctions.getCurrentDataViewProperty("smartToDoFilters", dataView),
    );

    ToDoList.setToDoFilterButtonDisplay("#todo-map-table", ".todo-subject-parent-div");
  };

  var updateToggleButtonText = function (action) {
    const $toggleBtn = $(".toggle-btn");
    if (action === "collapse") {
      $toggleBtn.text("Collapse All");
      $toggleBtn.data("action", "collapse");
    } else {
      $toggleBtn.text("Expand All");
      $toggleBtn.data("action", "expand");
    }
  };

  var isTodoTableCollapsing = function ($element) {
    return $element.find(".todo-list").hasClass("collapsing");
  };

  var toDoFilterButtonClick = function (e) {
    var $button = $(this);
    var $parentDiv = $button.parents(".todo-subject-parent-div");
    var sectionName = $parentDiv.data("subject");
    ToDoFiltersModal.renderAndShow(sectionName);
    e.stopPropagation();
  };

  var toDoFilterLabelClick = function (e) {
    if ($(e.target).hasClass("close-button")) {
      const $label = $(this);
      const filterSection = $label.data("filterSection");
      const toDoSection = $label.parents(".todo-subject-parent-div").data("subject");
      ToDoList.setToDoFilterSectionToDefault(toDoSection, filterSection);
      $label.remove();
    }
    e.stopPropagation();
  };

  var onRollUpClick = function () {
    // Trigger table.js headerClick on rollup click
    $(this).closest(".catchment-table-header").find("h3").click();
  };

  var updateToDoMapLayers = function () {
    const dataView = Tree.get("dataView");
    var layerName = DataViewFunctions.getDataViewConfig(dataView)["defaultLayers"][0];
    if (!layerName || !ToDoFunctions.isToDoLayer(layerName)) return;
    const forceEnabled = Tree.get("dataView") !== dataView;

    LayerFunctions.filterToDoLayer(layerName, undefined, undefined, undefined, forceEnabled);
    BmpFcsTodoController.updateBmpFcsLayersByTodo();
  };

  var getSelectedSubject = function () {
    return selectedSubject;
  };

  var setSelectedSubject = function (subject) {
    selectedSubject = subject;
    updateToDoMapLayers();
  };

  var getTodoIdSets = function () {
    return todoIdSets;
  };

  var getHighlightSubject = function () {
    return highlightSubject;
  };

  var setHighlightSubject = function (subject) {
    highlightSubject = subject;
  };

  return {
    init,
    update,
    expandTodoHeaderContainsIdbmp,
    reselectExpandedHeader,
    renderToDoMapTable,
    updateToDoMapLayers,
    _setDataView,
    _getToDoDataSubjectData,
    getSelectedSubject,
    setSelectedSubject,
    getTodoIdSets,
    getHighlightSubject,
    setHighlightSubject,
  };
};

module.exports = ToDoMapTable();

const Actions = require("../actions");
const BmpFcsTodoController = require("../bmpfcs/bmpFcsToDoController");
const DataViewFunctions = require("../dataViewFunctions");
const LayerFunctions = require("../layerFunctions");
const Mobile = require("../mobile");
const ToDoConfig = require("../config/toDoConfig");
const ToDoFiltersModal = require("./toDoFiltersModal");
const ToDoFunctions = require("./toDoFunctions");
const ToDoList = require("./toDoList");
const ToDoListController = require("./toDoListController");
const Tree = require("../tree");
const MainMapController = require("./mainMapController");
const SmartFilterRegistry = require("../filters/smartFilterRegistry");
